module.exports = __webpack_public_path__ + "static/fonts/OpenSans-SemiBold.0cb4787.woff";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/OpenSans-SemiBold/OpenSans-SemiBold.woff
// module id = 0GDT
// module chunks = 16